<template>
  <v-dialog :value="showRecordForm" @input="v => v || HIDE_RECORD_FORM()" max-width="600px" scrollable>
    <v-card>
      <!-- TITLE -->
      <v-card-title class="primary">
        <span class="headline">{{ editMode ? 'تعديل المترجم' : 'اضافة مترجم'}}</span>
      </v-card-title>

      <!-- INPUTS -->
      <v-card-text class="pt-5 pb-0">
        <v-container>
          <v-progress-linear
            v-if="formLoading"
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <div v-else>
            <v-text-field
              dense
              outlined
              label="الاسم"
              prepend-icon="mdi-tie"
              v-model="form.name"
              :error-messages="errors.name"
            ></v-text-field>

            <v-file-input
              dense
              outlined
              label="صورة المترجم"
              prepend-icon="mdi-image"
              accept="image/*"
              v-model="form.image"
              :error-messages="errors.image"
            ></v-file-input>

            <v-textarea
              dense
              clearable
              outlined
              label="نبذة عن المترجم"
              v-model="form.bio"
              :error-messages="errors.bio"
            ></v-textarea>
          </div>
        </v-container>
      </v-card-text>

      <!-- ACTIONS -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          dark
          color="primary"
          elevation="1"
          :loading="formLoading"
          @click="editMode ? update(form) : create(form)"
        >حفظ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'record-form',


  data: function () {
    return {
      form: {},
      errors: {},
      formLoading: false,
    }
  },


  computed: {
    ...mapState(
      'translators',
      {
        editMode: state => state.editMode,
        showRecordForm: state => state.showRecordForm,
        recordForm: state => {
          return {
            id: state.recordForm.id,
            name: state.recordForm.name,
            bio: state.recordForm.bio,
          };
        }
      }
    )
  },


  watch: {
    recordForm(form) { this.form = form; }
  },


  methods: {
    ...mapMutations(
      'translators',
      [
        'HIDE_RECORD_FORM'
      ]
    ),

    create(form) {
      this.formLoading = true;

      this.$store.dispatch('translators/create', { form })
        .then((response) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم إضافة مترجم بنجاح',
            color: 'success'
          });

          this.$emit('update');
          this.HIDE_RECORD_FORM();
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر إضافة مترجم',
            color: 'accent'
          });
        })
        .finally(() => {
          this.formLoading = false;
        });
    },

    update(form) {
      this.formLoading = true;

      this.$store.dispatch('translators/update', { form })
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم تعديل البيانات بنجاح',
            color: 'success'
          });

          this.$emit('update');
          this.HIDE_RECORD_FORM();
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر تعديل البيانات',
            color: 'accent'
          });
        })
        .finally(() => {
          this.formLoading = false;
        });
    }
  }
}
</script>
